import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongDetailsLessonActions.module.scss";
import {SongDetailsLessonSongLibraryAction} from "../lesson-song-library-action/SongDetailsLessonSongLibraryAction";
import {SongDetailsLessonPlayAction} from "../lesson-play-action/SongDetailsLessonPlayAction";
import {
  SongDetailsLessonNoSongLibraryAccessActions
} from "../../components/lesson-no-song-library-access-actions/SongDetailsLessonNoSongLibraryAccessActions";
import {
  WhenUserHasSongLibraryAccess
} from "../../../../../../components/conditional/user-has-song-library-access/WhenUserHasSongLibraryAccess";



export interface ISongDetailsLessonActionsProps {
}

export const SongDetailsLessonActions: VoidFunctionComponent<ISongDetailsLessonActionsProps> = ({}) => {

  return (
    <div className={s.lessonActions}>
      <WhenUserHasSongLibraryAccess>
        <SongDetailsLessonSongLibraryAction />
        <SongDetailsLessonPlayAction />
      </WhenUserHasSongLibraryAccess>
      <WhenUserHasSongLibraryAccess not>
        <SongDetailsLessonNoSongLibraryAccessActions />
      </WhenUserHasSongLibraryAccess>
    </div>
  );
}
